import { JiraPodReport } from '@Models/types';
import { startOfWeek, endOfWeek, getISOWeek, format, subWeeks } from 'date-fns';

type TicketArray = JiraPodReport['tickets'];

export type GroupedTickets = {
  high: TicketArray;
  mid: TicketArray;
  low: TicketArray;
  unclassified: TicketArray;
};

export function groupTicketsByConfidence(tickets: TicketArray): GroupedTickets {
  const high = tickets.filter(
    (t) =>
      t.ticket.classification !== undefined &&
      t.ticket.classification.confidence_score >= 70
  );
  const mid = tickets.filter(
    (t) =>
      t.ticket.classification !== undefined &&
      t.ticket.classification.confidence_score >= 30 &&
      t.ticket.classification.confidence_score < 70
  );
  const low = tickets.filter(
    (t) =>
      t.ticket.classification !== undefined &&
      t.ticket.classification.confidence_score < 30
  );
  const unclassified = tickets.filter(
    (t) => t.ticket.classification === undefined
  );
  return { high, mid, low, unclassified };
}

export function getCurrentWeekRange() {
  const today = new Date();

  // Start on Monday, end on Sunday
  const monday = startOfWeek(today, { weekStartsOn: 1 }); // 1 = Monday
  const sunday = endOfWeek(today, { weekStartsOn: 1 }); // still ends on Sunday

  const week = `${monday.getFullYear()}-W${String(getISOWeek(monday)).padStart(2, '0')}`;
  const duration = `${format(monday, 'yyyy-MM-dd')} to ${format(sunday, 'yyyy-MM-dd')}`;

  return { week, duration };
}

export function getPreviousWeekRange() {
  const today = new Date();

  // Move one week back
  const lastWeek = subWeeks(today, 1);

  // Start on Monday, end on Sunday for the previous week
  const monday = startOfWeek(lastWeek, { weekStartsOn: 1 });
  const sunday = endOfWeek(lastWeek, { weekStartsOn: 1 });

  const week = `${monday.getFullYear()}-W${String(getISOWeek(monday)).padStart(2, '0')}`;
  const duration = `${format(monday, 'yyyy-MM-dd')} to ${format(sunday, 'yyyy-MM-dd')}`;

  return { week, duration };
}
